import { ValueProvider } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { EntityConnectorInterface } from 'app/core/connector-services/entity-connector-service.interface';

import { TaskInterface } from 'app/task/models';

import { TaskRestConnectorService } from './task-rest-connector.service';
import { TaskServiceFilters } from './task.service';

export class TaskRestConnectorServiceStub implements EntityConnectorInterface<TaskInterface> {

  constructor(private readonly _tasks: TaskInterface[], private readonly _alwaysError: boolean = false) {}

  public loadAll(taskServiceFilters?: Readonly<TaskServiceFilters>): Observable<TaskInterface[]> {
    return this._alwaysError ? throwError('') : of(this._tasks);
  }

  public loadOne(id: number): Observable<TaskInterface> {
    return this._alwaysError ? throwError('') : of(this._tasks.pop());
  }

  public loadOneByUserId(userId: number): Observable<Readonly<TaskInterface>> {
    throw new Error('Method not implemented.');
  }

  public update(entity: TaskInterface): Observable<TaskInterface> {
    return this._alwaysError ? throwError('') : of(this._tasks.pop());
  }
}

export function taskRestConnectorServiceStubProvider(tasks: TaskInterface[], alwaysError: boolean = false): ValueProvider {
  return {
    provide: TaskRestConnectorService,
    useValue: new TaskRestConnectorServiceStub(tasks, alwaysError),
  };
}
